import { all, put, takeEvery } from 'redux-saga/effects'
// import { SUCCESS, FAILED } from 'crom-api-constants';
import _ from 'lodash'

import { SIZE_CHANGE_SHOW_TABLE } from './constants'

import {} from './actions'

import { transformSizeData } from './helpers'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockDataTransformed,
    blockSaveCustomData,
} from '../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../config'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.velikost.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)
    const turnover = _.get(data, 'turnover', null)
    const profit = _.get(data, 'profit', null)
    const capital = _.get(data, 'capital', null)
    const employee = _.get(data, 'employee', null)

    // Transformation START
    const transformedData = {
        ...transformSizeData(turnover, profit, employee), // Returns transformed turnover, profit and employees (capital has a different graph)
        capital: _.reduce(
            capital,
            (acc, capitalObj) => {
                const text = _.get(capitalObj, 'year', '').toString()
                const equity = _.get(capitalObj, 'equity', null) // Vlastní kapitál
                const registeredCapital = _.get(capitalObj, 'registered', null) // Základní kapitál
                const equityValue = _.get(equity, 'amount', null)
                const registeredCapitalValue = _.get(registeredCapital, 'amount', null)
                const isDefined = !_.isNil(equity)

                const upperLimit = equityValue && equityValue >= 0 ? equityValue : 0
                const lowerLimit = equityValue && equityValue < 0 ? equityValue : 0

                return [
                    ...acc,
                    {
                        text,
                        upperLimit,
                        lowerLimit,
                        isDefined,
                        equity,
                        registeredCapital,
                        lineValue: registeredCapitalValue,
                    },
                ]
            },
            []
        ),
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))
    // Transformation END

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            showProfitTable: false,
            showTurnoverTable: false,
            showCapitalTable: false,
            showEmployeeTable: false,
        })
    )

    return null
}

function* changeCustomDataSaga(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.velikost.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* sizeSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, onDataLoaded), takeEvery(SIZE_CHANGE_SHOW_TABLE, changeCustomDataSaga)])
}
